import { Link } from 'react-router-dom';

export default function RoomAssignmentScreen() {
  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-center p-6"
      style={{
        backgroundImage:
          "url('https://miro.medium.com/v2/resize:fit:1140/1*GMQCWnvQJj6SD_zb7Jo8jw.png')",
      }}
    >
      <div className="bg-white bg-opacity-80 p-12 rounded-2xl shadow-2xl text-center max-w-3xl w-full border border-gray-300">
        <h1 className="text-6xl font-extrabold text-gray-900 mb-8">Room Assigned</h1>
        <p className="text-xl font-medium text-gray-700 mb-8">
          Congratulations! Your room has been assigned. Please proceed to the front desk to collect
          your keys.
        </p>
        <div className="flex flex-col items-center gap-6">
          <p className="text-lg text-gray-600">
            For assistance, contact reception at{' '}
            <span className="font-semibold">+123 456 7890</span>
          </p>

          <Link to={'/'}>
            <button className="bg-black text-white px-10 py-4 rounded-lg text-xl font-semibold shadow-md hover:text-gray-300 transition duration-300">
              Collect Keys
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
}

// export default function RoomAssignmentScreen() {
//     return (
//       <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-gray-200 to-gray-400 p-6">
//         <div className="bg-white p-12 rounded-2xl shadow-2xl text-center max-w-xl w-full border border-gray-300">
//           <h1 className="text-5xl font-extrabold text-gray-900 mb-6">Room Assigned</h1>
//           <p className="text-lg text-gray-700 mb-6">Congratulations! Your room has been assigned. Please proceed to the front desk to collect your keys.</p>
//           <div className="flex flex-col items-center gap-4">
//             <p className="text-md text-gray-600">For assistance, contact reception at <span className="font-semibold">+123 456 7890</span></p>
//             <button className="bg-black text-white px-8 py-3 rounded-lg text-lg font-semibold shadow-md hover:text-gray-300 transition duration-300">
//               Collect Keys
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }
